import { useQuery } from "@tanstack/react-query";
import { fetchGoogleStatus } from "@/api/oauth";

/**
 * 3.1A — current user's Google Calendar connection status.
 * Read-only; the Settings page renders connection/sync state from this.
 */
export function useGoogleStatus(enabled = true) {
  return useQuery({
    queryKey: ["oauth", "google", "status"],
    queryFn: ({ signal }) => fetchGoogleStatus(signal),
    enabled,
    staleTime: 30_000,
  });
}
